class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.initFacets();
  }

  initFacets() {
    const component = this;
    component.sortForm = component.classList.contains('sort_form') ? true : false;
    let isNewUI = false;
    if (component.sortForm === false) {
      component.version = component.dataset.v2 === 'true' ? 2 : 1;
      isNewUI = component.version == 2;

      if (isNewUI) {
        component.setExternalSizeEvents();
        const applyButton = component.querySelector('#mobile-facets-apply');
        applyButton.addEventListener('click', (event) => {
          // The new filter UI applies on click only: submit the staged filters
          // (this serializes the drawer form, which serves both mobile and the shared
          // desktop drawer), then close the drawer.
          component.onSubmitHandler(event);
          component.closest('drawer-element').querySelector('#close-mobile-facets').click();
        });
      }
    }

    component.onActiveFilterClick = component.onActiveFilterClick.bind(component);

    // The new filter UI (the data-v2 drawer form on collection pages) applies filters
    // ONLY when the Apply button is clicked — both on mobile and via the shared desktop
    // drawer — so there is no debounced auto-submit on change. Sort forms and the old
    // filter UI (search pages) keep the original debounced auto-apply (500ms).
    if (isNewUI) {
      // No auto-submit. On input we only track the last-selected colour and keep the
      // footer Clear/Apply buttons enabled so Apply stays clickable; the actual submit
      // happens in the #mobile-facets-apply click handler above.
      const facetForm = component.querySelector('form');
      facetForm.addEventListener('input', (event) => {
        document
          .querySelectorAll('[name="filter.p.m.filter.color"]')
          .forEach((input) => input.removeAttribute('last-selected-color'));
        if (event.target.checked && event.target.name === 'filter.p.m.filter.color') {
          event.target.setAttribute('last-selected-color', true);
        }
        const form = event.target.closest('form');
        if (form && form.id == 'FacetFiltersFormMobile') {
          const hasCheckedInputs = form.querySelectorAll(':checked').length > 0;
          document
            .querySelectorAll('#mobile-facets-clear')
            .forEach((btn) => btn.toggleAttribute('disabled', !hasCheckedInputs));
          document
            .querySelectorAll('#mobile-facets-apply')
            .forEach((btn) => btn.toggleAttribute('disabled', !hasCheckedInputs));
        }
      });
    } else {
      component.debouncedOnSubmit = debounce((event) => {
        document
          .querySelectorAll('[name="filter.p.m.filter.color"]')
          .forEach((input) => input.removeAttribute('last-selected-color'));
        if (event.target.checked && event.target.name === 'filter.p.m.filter.color') {
          event.target.setAttribute('last-selected-color', true);
        }
        component.onSubmitHandler(event);
        const form = event.target.closest('form');
        if (form.id == 'FacetFiltersFormMobile') {
          const mobileClear = document.querySelectorAll('#mobile-facets-clear');
          const mobileApply = document.querySelectorAll('#mobile-facets-apply');
          const hasCheckedInputs = form.querySelectorAll(':checked').length > 0;

          if (hasCheckedInputs) {
            mobileClear.forEach((btn) => btn.removeAttribute('disabled'));
            mobileApply.forEach((btn) => btn.removeAttribute('disabled'));
          } else {
            mobileClear.forEach((btn) => btn.setAttribute('disabled', true));
            mobileApply.forEach((btn) => btn.setAttribute('disabled', true));
          }
        }
      }, 500);

      const facetForm = component.querySelector('form');
      facetForm.addEventListener('input', component.debouncedOnSubmit.bind(component));
    }

    const facetWrapper = component.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    component.setInternalSizeEvent();
  }

  //disables other inputs once you the user selects a size. Needed so that user can't select alpha size, band size and cup size at the same time.
  setInternalSizeEvent() {
    this.internalInputs = this.querySelectorAll('input');
    this.internalInputs.forEach(input => {
      if(input.name.includes('size')) { // targeting only the size inputs
        input.addEventListener('change', this.disableSizes.bind(this));
      }
    });
  }

  disableSizes(e) {
    const alphaSizeInputName = 'filter.v.option.size';
    if(e.currentTarget.checked) {
      const enabledSizeName = e.currentTarget.name;
      let isAlphaSize = false;
      if (enabledSizeName == alphaSizeInputName) {
        isAlphaSize = true
      }
      else {
        isAlphaSize = false
      }
      const inputs = this.querySelectorAll('input');
      inputs.forEach(input => {
        if (isAlphaSize) { // if alpha size filter is checked, disable band size and cup size filters
          if(input.name.includes('size') && input.name != enabledSizeName) { // targets cup size and band size filters
              input.disabled = true;
          }
        }
        else { // if band size and cup size filter is checked, disable alpha size filter
          if(input.name == alphaSizeInputName) { // targets alpha size filter
            input.disabled = true;
          }
        }
      });
    }
  }

  //sets the event listeners for the size shortcuts on the Sale collection
  setExternalSizeEvents() {
    this.externalSizeInputs = this.closest('aside').querySelectorAll('ul.facets__list.facets__list-custom-tabs .facets__item input[type=checkbox]');
    this.externalSizeInputs.forEach( input => {
      input.addEventListener('change', (event) => {
        const target = event.currentTarget;
        const size = target.value;
        // Quick-filter shortcuts apply IMMEDIATELY (unlike in-drawer changes, which
        // wait for Apply): stage the matching drawer filter, then submit. We revert
        // the shortcut's own native toggle first so its :checked state — which the
        // shortcut styling keys off — only flips when renderPage re-syncs it AFTER
        // the fetch, keeping the shortcut in step with the products and the
        // active-filter pills.
        target.checked = !target.checked;
        const targetedSizeFilterEl = this.querySelector(`drawer-element facet-filters-form form input[value="${size}"]`);
        targetedSizeFilterEl.click();
        this.onSubmitHandler(event);
      });
    });
  }
  
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);

    const closeMobileFacets = (event) => {
      document.getElementById('close-mobile-facets').click();
    };
    // Close-on-Apply/Clear applies only to the old filter UI (search pages). The new
    // filter UI's Apply button (data-v2 drawer form) closes the drawer in its own
    // submit handler wired in initFacets — binding here too would click
    // #close-mobile-facets twice, and drawer.js toggleDrawer() is a toggle, so the
    // drawer would close and instantly reopen. Its Clear link leaves the drawer open.
    const isNewUIButton = (el) => el.closest('facet-filters-form')?.dataset.v2 === 'true';
    const mobileApply = document.getElementById('mobile-facets-apply');
    const mobileClear = document.getElementById('mobile-facets-clear');
    if (mobileApply && !isNewUIButton(mobileApply)) mobileApply.addEventListener('click', closeMobileFacets);
    if (mobileClear && !isNewUIButton(mobileClear)) mobileClear.addEventListener('click', closeMobileFacets);

    const closeDesktopFacets = (event) => {
      const facet = event.currentTarget.closest('.parent-display').getAttribute('id');
      document.querySelector(`[aria-controls="${facet}"]`).click();
    };
    document
      .querySelectorAll('.desktop-facets-apply')
      .forEach((button) => button.addEventListener('click', closeDesktopFacets));

    const trackFacetRemoval = (event) => {
      const facet = event.currentTarget.getAttribute('data-value');
      const formAnalytics = {
        event: 'filter_engagement',
        event_category: 'filter_option',
        event_action: 'deselect',
        event_label: facet,
      };
      window.dataLayer.push(formAnalytics);
    };

    const updateFilterHeight = (event) => {
      const target = event.currentTarget;
      const root = document.documentElement;
      if (target.querySelector('.facets__display')) {
        const newHeight = target.querySelector('.facets__display').offsetHeight + 24;
        root.style.setProperty('--facet-margin-top', newHeight + 'px');
      }
    };

    document
      .querySelectorAll('.active-facets__button')
      .forEach((button) => button.addEventListener('click', trackFacetRemoval));

    document.querySelectorAll('.js-filter').forEach((filter) => filter.addEventListener('click', updateFilterHeight));
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static swatchCarouselOptions = {
    autoplay: false,
    slidesToShow: 6,
    slidesToScroll: 5,
    mobileFirst: true,
    infinite: false,
    prevArrow: '<div class="swatch-slider-prev"><button class="swatch-slider-prev-arrow" type="button"></button></div>',
    nextArrow: '<div class="swatch-slider-next"><button class="swatch-slider-next-arrow" type="button"></button></div>',
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 7,
        },
      },
    ],
  };

  static swatchResizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      $(entry.target).slick('resize');
    }
  });

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    const promises = sections.map((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      // FacetFiltersForm.filterData.some(filterDataUrl) ?
      //   FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      return FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    Promise.all(promises).then(() => {
      document.querySelector('product-grid-container')?.initAjaxinate();
      // Sync the custom size shortcuts AFTER the grid + active-filter pills have
      // re-rendered, so their :checked-based styling flips in step with the applied
      // filters instead of the instant a box is ticked. Pairs with the revert in
      // setExternalSizeEvents.
      document.querySelectorAll('.facets__list-custom-tabs').forEach((section) => {
        section.querySelectorAll('input').forEach((input) => {
          if (searchParams.includes(input.name) && searchParams.includes(`=${input.value}&`)) {
            input.checked = true;
          } else {
            input.checked = false;
          }
        });
      });
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    return fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        const lastSelectedColor = document.querySelector('[last-selected-color]')?.value;
        document.querySelectorAll(`[data-generic-color=${lastSelectedColor}]`).forEach((element) => element.click());

        if (url.includes('collection-grid')) {
          const gridItems = document.querySelectorAll('.Grid-item,.product-card');
          gridItems.forEach((gridItem, i) => {
            gridItem.classList.remove('product-card--showMinHeightMobile');
            gridItem.classList.remove('product-card--showMinHeightDesktop');

            let checkList;

            if (window.innerWidth < 768) {
              if (i % 2 === 0) {
                checkList = [gridItem, gridItem.nextElementSibling];
              } else {
                checkList = [gridItem, gridItem.previousElementSibling];
              }
            } else {
              if (i % 3 === 0) {
                const nextItem = gridItem.nextElementSibling ? gridItem.nextElementSibling.nextElementSibling : null;
                checkList = [gridItem, gridItem.nextElementSibling, nextItem];
              } else if ((i - 1) % 3 === 0) {
                checkList = [gridItem, gridItem.previousElementSibling, gridItem.nextElementSibling];
              } else if (i % 3 === 2) {
                const prevItem = gridItem.previousElementSibling
                  ? gridItem.previousElementSibling.previousElementSibling
                  : null;
                checkList = [gridItem, gridItem.previousElementSibling, prevItem];
              }
            }

            if (checkList) {
              checkList.forEach((el) => {
                if (!el || !el.querySelector('.GridItem-titleLink')) return; // prev or next may not exist
                if (window.innerWidth < 768) {
                  if (el.querySelector('.GridItem-titleLink').textContent.trim().length > 22) {
                    gridItem.classList.add('product-card--showMinHeightMobile');
                    return;
                  }
                } else {
                  if (el.querySelector('.GridItem-titleLink').textContent.trim().length > 32) {
                    gridItem.classList.add('product-card--showMinHeightDesktop');
                    return;
                  }
                }
              });
            }
          });

          dispatchEvent(new CustomEvent('collection-filter-fetch'));
        }
        document.querySelector('drawer-element facet-filters-form').setInternalSizeEvent();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
  }

  static renderProductGridContainer(html) {
    const gridContainer = document.getElementById('ProductGridContainer');
    gridContainer.innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    facetDetailsElements.forEach((element) => {
      const facet = document.querySelectorAll(`.js-filter[data-index="${element.dataset.index}"]`);

      if(facet) {
        facet.forEach(f => {
          if(f.classList.contains('js-filters-v2')) {
          }
          f.innerHTML = element.innerHTML;

          if (f.querySelector('.desktop-facets-apply')) {
            f.querySelector('.desktop-facets-apply').addEventListener('click', (event) => {
              document.querySelector(`[aria-controls="${f.getAttribute('id').replace('Details', 'Facet')}"]`).click();
            });
          }
        });
        // facet.innerHTML = element.innerHTML;

        // if (facet.querySelector('.desktop-facets-apply')) {
        //   facet.querySelector('.desktop-facets-apply').addEventListener('click', (event) => {
        //     document.querySelector(`[aria-controls="${facet.getAttribute('id').replace('Details', 'Facet')}"]`).click();
        //   });
        // }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    window.addDetailsListeners(document.getElementById('FacetFiltersForm'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile-v1', '.active-facets-desktop', '.active-facets-mobile-v2'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      if(document.querySelector(selector)){
        document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;

        const activeFacetsCount = document.querySelectorAll(`${selector} .active-facets__button`);

        if (activeFacetsCount.length > 0) {
          document.querySelector(selector).classList.add('active');
        } else {
          document.querySelector(selector).classList.remove('active');
        }
      }
      
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }
  

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    //We get the target and source 'Apply' buttons to check if we should enable/disable it based on the selected filters
    const targetApplyFiltersElement = target.querySelector('.desktop-facets-apply');
    const sourceApplyFiltersElement = source.querySelector('.desktop-facets-apply');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }

    if (targetApplyFiltersElement && sourceApplyFiltersElement) {
      targetApplyFiltersElement.disabled = sourceApplyFiltersElement.disabled;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(formData) {
    if (formData.toString().includes('filter.v.availability')) {
      return new URLSearchParams(formData).toString();
    }
    return new URLSearchParams(formData).toString().concat('&filter.v.availability=1');
  }

  createTrackingValues(formData) {
    const selectedValues = {};
    for (const pair of formData) {
      const key = pair[0].split('.').pop();
      const value = pair[1];
      selectedValues[key] ? selectedValues[key].push(value) : (selectedValues[key] = [value]);
    }
    return selectedValues;
  }

  onSubmitForm(searchParams, event, formAnalytics) {
    if (formAnalytics) window.dataLayer.push(formAnalytics);
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const formAnalytics = {
      event: 'filter_engagement',
      event_category: 'filter_option',
      event_action: 'submit',
      event_label: event.target.name?.split('.').pop(),
      active_filters: {},
    };

    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const formData = new FormData(event.target.closest('form'));
      const searchParams = this.createSearchParams(formData);
      formAnalytics.active_filters = this.createTrackingValues(formData);
      this.onSubmitForm(searchParams, event, formAnalytics);
    } else {
      const forms = [];
      let isMobile = false;
      if(this.version == '1') {
        isMobile = event.target.closest('form').id.includes('Mobile');
      }
      else {
        isMobile = true;
      }

      // The mobile filter drawer serializes the sort form and the filters form separately and
      // joins them. This happens for the new filter UI (data-v2, isMobile forced true)
      // and for the old filter UI on mobile (version 1, mobile form id). createSearchParams()
      // appended filter.v.availability=1 per form, so the join produced a duplicate
      // (?...availability=1...&...availability=1) which broke the variant-level availability
      // scope and surfaced products whose selected-size variant is sold out. For the mobile
      // join we serialize each form WITHOUT the per-form append and add a single
      // filter.v.availability=1 after the join. The single-form desktop path is unchanged.
      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            const formData = new FormData(form);
            formAnalytics.active_filters = this.createTrackingValues(formData);
            forms.push(this.createSearchParams(formData));
          }
        } else if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortFormMobile') {
          const formData = new FormData(form);
          formAnalytics.active_filters = this.createTrackingValues(formData);
          forms.push(new URLSearchParams(formData).toString());
        }
      });

      let searchParams;
      if (isMobile) {
        searchParams = forms.filter(Boolean).join('&');
        if (!searchParams.includes('filter.v.availability')) {
          searchParams = searchParams ? `${searchParams}&filter.v.availability=1` : 'filter.v.availability=1';
        }
      } else {
        searchParams = forms.join('&');
      }
      this.onSubmitForm(searchParams, event, formAnalytics);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
